import { useSortedLocalizedLifeAreas } from 'features/life-areas';
import {
  useLifeAreasSectionOpen,
  useSmartListsSectionOpen,
} from 'features/user';
import { MainNavigationItemId } from 'shared/routes/navigation/types/navigation-item';

export type SubItemDisclosure = {
  hasChildren: boolean;
  open: boolean;
  onToggle: () => void;
};

// Smart lists persist their fold state on the user doc, life areas per-browser — deliberately different.
export const useSubItemDisclosure = (
  id: MainNavigationItemId,
): SubItemDisclosure | undefined => {
  const lifeAreas = useSortedLocalizedLifeAreas({ activeOnly: true });
  const [smartListOpen, setSmartListOpen] = useSmartListsSectionOpen();
  const [lifeAreasOpen, setLifeAreasOpen] = useLifeAreasSectionOpen();

  // The all-tasks fold always holds the create-smart-list item, so it is never empty.
  if (id === MainNavigationItemId.AllTasks) {
    return {
      hasChildren: true,
      open: smartListOpen,
      onToggle: () => setSmartListOpen((prev) => !prev),
    };
  }

  if (id === MainNavigationItemId.LifeAreas) {
    return {
      hasChildren: !!lifeAreas.length,
      open: lifeAreasOpen,
      onToggle: () => setLifeAreasOpen(!lifeAreasOpen),
    };
  }

  return undefined;
};
